import { RequisitionLineSap } from "./requisition-line-sap";

export class RequisitionSap {
    docEntry:number = 0;
    docNum:number = 0;
    docDate:Date = new Date();
    docDueDate:Date = new Date();
    project:string = '';
    warehouse:string = 'P1RS';
    documentsOwner:number = 0;
    dbname:string = '';
    comment:string = '';
    lines:RequisitionLineSap[] = [];
}
